import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import CleaningServicesOutlinedIcon from "@mui/icons-material/CleaningServicesOutlined";
import EventAvailableOutlinedIcon from "@mui/icons-material/EventAvailableOutlined";

const steps = [
  {
    number: "01",
    title: "Find Us Fast Now",
    text: "They provide convenience and ensure a hygienic living.",
    color: "#7ac142",
    Icon: PersonSearchOutlinedIcon,
  },
  {
    number: "02",
    title: "Choose Services",
    text: "They provide convenience and ensure a hygienic living.",
    color: "#ffc93b",
    Icon: CleaningServicesOutlinedIcon,
  },
  {
    number: "03",
    title: "Book Appointment",
    text: "They provide convenience and ensure a hygienic living.",
    color: "#287bff",
    Icon: EventAvailableOutlinedIcon,
  },
];

const HowItWorksSection = () => {
  return (
    <>
      <style>{`
        /* LABEL */
        .hiw-label-wrap {
        display: inline-flex;
        align-items: center;
        gap: 10px;
      }
        .hiw-label-line {
          width: 42px;
          height: 2px;
          background: #7ac142;
          border-radius: 10px;
        }

        /* CARD */
        .hiw-step-card {
        width: 100%;
        max-width: 340px;
        border-radius: 34px;
        border: 1px solid #e4e7f1;
        background: #ffffff;
        padding: 28px 26px 42px;
        transition: all 0.3s ease;
        height: 100%;
      }

        .hiw-step-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 24px 70px rgba(15, 23, 42, 0.08);
        }

        /* Bottom curve */
        

        /* INNER PILL */
        .hiw-step-inner {
          position: relative;
          z-index: 2;
          margin-top: 48px;
          border-radius: 22px;
          background: #f7f8fc;
          padding: 18px 22px;
          display: flex;
          align-items: center;
          gap: 16px;
        }

        /* ICON */
        .hiw-icon-wrap {
          width: 54px;
          height: 54px;
          border-radius: 50%;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          box-shadow: 0 10px 22px rgba(15, 23, 42, 0.14);
          perspective: 800px;
          flex-shrink: 0;
        }

        .hiw-icon-flip {
          width: 100%;
          height: 100%;
          position: relative;
          transform-style: preserve-3d;
          transition: transform 0.6s ease;
        }

        .hiw-icon {
          position: absolute;
          inset: 0;
          margin: auto;
          font-size: 30px;
          backface-visibility: hidden;
        }

        .hiw-icon.back {
          transform: rotateY(180deg);
        }

        .hiw-step-card:hover .hiw-icon-flip {
          transform: rotateY(180deg);
        }

        @media (max-width: 960px) {
          .hiw-step-card {
            padding: 28px 22px 56px;
          }
        }
      `}</style>

     <Box sx={{ py: 9 }}>
  {/* Heading */}
  <Box textAlign="center" mb={5}>
    <Box className="hiw-label-wrap" sx={{ justifyContent: "center", mb: 1 }}>
      <Box className="hiw-label-line" />
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: "0.18em",
          color: "#7ac142",
        }}
      >
        HOW IT WORK
      </Typography>
      <Box className="hiw-label-line" />
    </Box>

    <Typography
      sx={{
        fontSize: { xs: 26, md: 34 },
        fontWeight: 800,
        lineHeight: 1.2,
      }}
    >
      How Do We Executive
      <br />
      Cleaning Works
    </Typography>
  </Box>

  {/* Steps wrapper (IMPORTANT FIX) */}
  <Box
    sx={{
      maxWidth: 1200,
      mx: "auto",
      px: { xs: 2, md: 0 },
    }}
  >
    <Grid
      container
      spacing={3}
      sx={{
        flexWrap: "wrap",
      }}
    >
      {steps.map(({ number, title, text, color, Icon }, idx) => (
        <Grid item xs={12} md={4} key={idx}>
          <Box
            className="hiw-step-card"
            sx={{
              boxSizing: "border-box",
              width: "100%",
            }}
          >
            <Typography
              sx={{
                fontSize: 24,
                fontWeight: 800,
                color: "#dfe3f0",
              }}
            >
              {number}
            </Typography>

            <Box className="hiw-step-inner">
              <Box className="hiw-icon-wrap">
                <Box className="hiw-icon-flip">
                  <Icon className="hiw-icon front" sx={{ color }} />
                  <Icon className="hiw-icon back" sx={{ color }} />
                </Box>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: 16,
                    mb: 0.4,
                  }}
                >
                  {title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: 13,
                    color: "text.secondary",
                    lineHeight: 1.6,
                  }}
                >
                  {text}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  </Box>
</Box>

    </>
  );
};

export default HowItWorksSection;
